import { UserService } from './UserService';
import { ReportService } from './ReportService';
import { AdminService } from './AdminService';
import { Mt5Service } from './Mt5Service';

export const Service = {
  User: UserService,
  Report: ReportService,
  Admin: AdminService,
  Mt5: Mt5Service
};
